import { Inject } from '@odinjs/odin';

import { catchRenderException, Endpoint } from '@philips-emr/hpms-stipulator-commons';
import { TabWithContentAPI } from '@philips-emr/tws-components';
import Controller, { OnClick, OnMount } from '@philips-emr/tws-core/lib/client';
import { MountEvent } from '@philips-emr/tws-core/lib/component/types';
import { HttpService } from '@philips-emr/tws-core/lib/services';

import { TipoOrigemAnexo } from '../anexo-tiss/anexo-tiss-controller';
import BaseController from '../BaseController';

import './autorizacao-dados-guia-controller.css';

@Controller({ fragment: 'historico-autorizacao' })
export default class HistoricoAutorizacaoController extends BaseController {

  @Inject('tab-with-content-anexos-tiss')
  private tabWithContentAnexosTiss: TabWithContentAPI;

  private showTabAnexosTiss: boolean = false;

  private init(): void {
    this.showTabAnexosTiss = false;
  }

  @OnMount({ target: 'panel-historico-autorizacao' })
  public onMountLayoutAutorizacaoDadosGuia(): void {
    this.init();

    const origem = TipoOrigemAnexo.ANEXOS_TISS_AUTORIZACOES;
    const { nrSeqContrato, nrSeqGuia } = this.historyService.getCurrentRouteParams();

    this.fetchAutorizacaoGuiaShow(nrSeqContrato, nrSeqGuia, origem);
    this.context.set({ origem, nrSequencia: nrSeqGuia });
  }

  @OnMount({ target: 'tab-with-content-anexos-tiss' })
  public onMountContentAnexoTiss(event: MountEvent): void {
    const api = event.target as unknown as TabWithContentAPI;
    api.setVisible(this.showTabAnexosTiss);
  }

  @OnClick({ target: 'tab-with-content-dados-guia' })
  public onClickTabDadosGuia(): void {
    this.tabWithContentAnexosTiss.setVisible(this.showTabAnexosTiss);
  }

  private fetchAutorizacaoGuiaShow(nrSeqContrato: number | string, nrSequencia: number | string, origem: TipoOrigemAnexo): void {
    void HttpService.get<number>(Endpoint.GET.SHOW_ANEXO_TISS, { nrSeqContrato, nrSequencia, origem })
      .then(({ body }) => {
        this.showTabAnexosTiss = body ? body > 0 : false;
        catchRenderException(() => this.tabWithContentAnexosTiss.setVisible(this.showTabAnexosTiss));
      });
  }

}
